import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-helpbutton-reports-assistancephysicalnumber-card',
  templateUrl: './helpbutton-reports-assistancephysicalnumber-card.component.html',
  styleUrls: ['./helpbutton-reports-assistancephysicalnumber-card.component.scss']
})
export class HelpbuttonReportsAssistancephysicalnumberCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
